import type { HeroSlideInput } from '@shop-monorepo/types';
import React from 'react';

import { useCreateHeroSlide } from '@/hooks/useHeroSlideQueries';
import { useListReturn } from '@/hooks/useListReturn';
import { ROUTES } from '@/routes/routes';

import { HeroSlideForm } from './HeroSlideForm';

export const CreateHeroSlideForm: React.FC = () => {
  const { goToList } = useListReturn(ROUTES.HERO_SLIDES);
  const { mutate: createHeroSlide, isPending: isSubmitting } = useCreateHeroSlide();

  const handleSubmit = async (values: HeroSlideInput) => {
    createHeroSlide(values, {
      onSuccess: () => {
        goToList();
      },
    });
  };

  return <HeroSlideForm onSubmit={handleSubmit} isSubmitting={isSubmitting} />;
};
